import '../css/trend.page.css';

import $ from 'jquery';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
Exporting(Highcharts);
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
NoDataToDisplay(Highcharts);
import { appConstants } from './app-constants';
import { configureCharts } from './chart-config';
import { Tab, Popover } from 'bootstrap';
import { showLoadingSpinner, hideLoadingSpinner } from './loading';

class TrendPage {

    filters = {
        state: 0,
        vaccine: 0,
        ageGroup: 0,
        gender: 0,
        ethnicity: 0,
        timePeriod: 0,
        timePeriod2: 0,
        payer: 0
    }

    currentTab = 'totals';
    popover = null;

    viewModel = null;

    constructor() {
        // View model is initialized on script for page
        this.viewModel = viewModel;
        this.init();
    }

    init() {
        configureCharts(Highcharts);
        this.populateFilterState();
        this.setDefaultFilters();
        this.populateFilters();
        this.addTabChangeHandler();
        this.populateTabState();
        this.populateAgeFilter();
        this.addFilterChangeHandlers();
        this.populateState();

        this.populateYear();

        this.populateVaccineInfo();

        this.populateLatestTrends();
    }

    setDefaultFilters() {
        if (!this.filters.state) {
            this.filters.state = appConstants.national;
        }
        if (!this.filters.ageGroup) {
            this.filters.ageGroup = appConstants.ageGroup;
        }
        if (!this.filters.vaccine) {
            this.filters.vaccine = appConstants.influenza;
            $('#vaccineFilter').val(this.filters.vaccine);
        }
        if (!this.filters.timePeriod) {
            this.filters.timePeriod = appConstants.timePeriod;
        }
        if (!this.filters.timePeriod2) {
            this.filters.timePeriod2 = appConstants.timePeriod2;
        }
    }

    populateFilters() {
        const keys = Object.keys(this.filters);
        keys.forEach(key => {
            const selector = `#${key}Filter`;
            if (this.filters[key]) {
                $(selector).val(this.filters[key]);
            }
        });
    }

    populateAgeFilter() {
        const url = `${appConstants.ageListUrl}?value=${this.filters.vaccine}`;
        $.getJSON(url, results => {
            let html = ''; //'<option value="0">All Age Groups</option>';
            results.forEach(result => {
                html += `<option value="${result.ageGroupId}">${result.ageGroup}</option>`;
            });
            $('#ageGroupFilter').html(html);

            // If the selected ageGroup does not exist in the list then select first item in age group list
            if (!results.find(x => x.ageGroupId === this.filters.ageGroup)) {
                this.filters.ageGroup = results[0].ageGroupId;
            }

            $('#ageGroupFilter').val(this.filters.ageGroup);
            this.populateCharts();
        });
    }

    populateTabState() {
        const searchParams = new URLSearchParams(window.location.search);
        const currTab = searchParams.get('tab');
        if (currTab) {
            this.currentTab = currTab;
        }
        const tabEl = document.querySelector(`#${this.currentTab}-tab`);
        const tab = new Tab(tabEl);
        tab.show();
    }

    addTabChangeHandler() {
        $('button[data-bs-toggle="tab"]').on('shown.bs.tab', event => {
            const tab = $(event.target).attr('aria-controls');
            this.currentTab = tab;
            $('.sidebar-tab-content .tab-pane').removeClass('active');
            $(`#sidebar-${tab}`).addClass('active');
            const url = new URL(window.location.href);
            url.searchParams.set('tab', tab);
            // Reset the time period if the year is 2019
            if (this.currentTab === 'gap' && this.filters.timePeriod === 2019) {
                this.filters.timePeriod = appConstants.timePeriod;
                this.filters.timePeriod2 = appConstants.timePeriod2;
                url.searchParams.set('timePeriod', this.filters.timePeriod);
                url.searchParams.set('timePeriod2', this.filters.timePeriod2);
                this.populateCharts();
            }
            window.history.replaceState(null, null, url);
            this.populateYear();
            this.initializePopover();
        });
    }

    addFilterChangeHandlers() {
        const keys = Object.keys(this.filters);
        keys.forEach(key => {
            const selector = `#${key}Filter`;
            $(selector).on('change', e => {
                this.handleFilterSelect(key, e.currentTarget.value);
            });
        });
    }

    handleFilterSelect(key, value) {
        this.filters[key] = parseInt(value);

        const url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.replaceState(null, null, url);

        if (key === 'vaccine') {
            this.filters.ageGroup = appConstants.ageGroup; // Reset age group to 0 when vaccine filter changes
            url.searchParams.set('ageGroup', appConstants.ageGroup);
            this.populateVaccineInfo();
            this.populateAgeFilter();
        } else { // populate charts is done through age filter for vaccines
            if (key === 'state') {
                this.populateState();
            }
            this.populateCharts();
        }
    }

    populateFilterState() {
        let filterParams = new URLSearchParams(window.location.search);
        filterParams.forEach((value, key) => {
            this.filters[key] = parseInt(value);
        });
    }

    generateFilterPayload() {
        return {
            yearId: this.filters.timePeriod,
            prevYearId: this.filters.timePeriod2,
            monthId: 0,
            vaccineId: this.filters.vaccine,
            stateId: this.filters.state,
            genderId: this.filters.gender,
            ageRangeId: 0,
            ageGroupId: this.filters.ageGroup,
            ethnicityId: this.filters.ethnicity,
            pointOfAccessId: 0,
            payTypeId: this.filters.payer,
            projected: 0,
            month: 0
        }
    }

    populateYear() {
        const label = this.currentTab === 'gap' ?
            `${this.filters.timePeriod} vs ${this.filters.timePeriod2}` :
            `${this.filters.timePeriod}`;


        $('#gapAnalyticYearLabel').html(label);
        $('.gap-analytic-label').html(this.currentTab.charAt(0).toUpperCase() + this.currentTab.slice(1) + " analysis for ");

        if (this.currentTab === 'totals') {
            $('#gapAnalyticYearLabel').hide();
            $('.gap-analytic-label').html('Analysis for all years');
        } else {
            $('#gapAnalyticYearLabel').show();
        }
    }

    initializePopover() {
        // Remove existing popover
        if (this.popover) {
            this.popover.dispose();
        }

        const timePeriodButtonEl = document.querySelector('.time-period-button');
        this.popover = new Popover(timePeriodButtonEl, {
            html: true,
            customClass: 'time-period-popover',
            content: `
                <div class="row">
                    <div class="col-sm">
                        <label for="timePeriodFilter">${this.currentTab === 'gap' ? 'Main period' : 'Period'}</label>
                        <select id="timePeriodFilter" class="form-select">${this.renderTimePeriodOptions()}</select>
                    </div>
                    ${this.currentTab === 'gap' ?
                    `<div class="col-sm">
                            <label for="timePeriod2Filter">Comparative period</label>
                            <select id="timePeriod2Filter" class="form-select">${this.renderTimePeriod2Options()}</select>
                        </div>` : ''
                }
                </div>
            `,
            sanitize: false
        });

        $(timePeriodButtonEl).one('inserted.bs.popover', () => {
            $('#timePeriodFilter').on('change', e => {
                this.handleFilterSelect('timePeriod', e.currentTarget.value);
                this.populateYear();
                $('#timePeriod2Filter').html(this.renderTimePeriod2Options());
            });

            $('#timePeriod2Filter').on('change', e => {
                this.handleFilterSelect('timePeriod2', e.currentTarget.value);
                this.populateYear();
                $('#timePeriodFilter').html(this.renderTimePeriodOptions());
            });
        });
    }

    renderTimePeriodOptions() {
        const timePeriods = this.currentTab === 'gap' ? this.viewModel.timePeriodList.filter(x => x > this.filters.timePeriod2) : [...this.viewModel.timePeriodList];
        return timePeriods.map(timePeriod => {
            if (timePeriod === this.filters.timePeriod) {
                return `<option value="${timePeriod}" selected>${timePeriod}</option>`;
            } else {
                return `<option value="${timePeriod}">${timePeriod}</option>`;
            }
        }).join();
    }

    renderTimePeriod2Options() {
        const timePeriods = this.currentTab === 'gap' ? this.viewModel.timePeriodList.filter(x => x < this.filters.timePeriod) : [...this.viewModel.timePeriodList];
        return timePeriods.map(timePeriod => {
            if (timePeriod === this.filters.timePeriod2) {
                return `<option value="${timePeriod}" selected>${timePeriod}</option>`;
            } else {
                return `<option value="${timePeriod}">${timePeriod}</option>`;
            }
        }).join();
    }

    populateState() {
        const state = this.viewModel.stateList.find(s => s.value == this.filters.state);
        if (state) {
            $('#stateLabel').html(state.text);
        }
    }

    populateLatestTrends() {
        // TODO: Fetch trends from server
        $('.accordion-button').text('Vaccine Track Reveals Trends in Recommended Adult Vaccinations in the U.S.');
        $('#latestTrends .accordion-body').html(
            '<div class="d-none d-lg-block clearfix"><img src="/images/trends_2024q1-q3.png" width="100%" alt="Vaccine Track Reveals Trends in Recommended Adult Vaccinations in the U.S." />' +
            '<a class="btn btn-primary float-end m-2" title="Checkout these vaccination resources" href="/Resources/Updates">Archives</a></div>' +
            '<div class="d-lg-none">' +
            '<div>As we move into 2023, there are several exciting new developments that have implications for adult vaccine availability, coverage and access. These include not only the new policy changes included in the Inflation Reduction Act of 2022 (IRA) that expand and improve adult vaccine coverage for Medicare and Medicaid beneficiaries, but also the promise of new advancements in vaccine innovation for diseases such as respiratory syncytial virus (RSV).</div><br/>' +
            '<div>The COVID - 19 pandemic had a significant impact on decreasing routine immunization rates both for children and adults — but it also provided lessons learned on how to address equity issues and system barriers that can be leveraged moving forward to improve rates.This is especially important to protect against respiratory diseases as we saw this year with the “tripledemic.”</div><br/>' +
            '<div>Although recommended vaccines, excluding flu for adults, on average remain below pre - pandemic levels, building on these new developments in 2023 can drive improvements.There is also a tremendous opportunity now to re - envision a more systematic approach to adult vaccination by maximizing uptake to create healthier communities and a more resilient public health infrastructure. </div><br/>' +
            '<div>To learn more on the most recent insights updated on the platform, <a href="/Resources/">click here</a></div><br/>' +
            '</div>'
        );
    }

    populateVaccineInfo() {
        const vaccine = this.viewModel.vaccineList.find(s => s.value == this.filters.vaccine);
        var name = '';
        if (vaccine) {
            if (vaccine.text.toLowerCase() == 'total (excluding influenza)') {
                name = 'Total (excluding Influenza & RSV)';
            } else {
                name = vaccine.text;
            }
            $('#vaccineName').html(name);

            const vaccineDescription = this.viewModel.vaccineDescriptionList.find(s => s.value == vaccine.text);
            if (vaccineDescription) {
                $('#vaccineDetails').html(vaccineDescription.text);
            }
            const cdclink = this.viewModel.vaccineCDCLink.find(s => s.value == vaccine.text);
            if (cdclink) {
                $('#cdcLink').prop("href", cdclink.text);
            }
        }
    }

    populateCharts() {
        this.populateTotalsChart();
        this.populateGapTotalChart();
        this.populateGapAgeChart();
        this.populateGapGenderChart();
        this.populateGapEthnicityChart();
        this.populateGapPayerChart();
    }

    populateTotalsChart() {
        const url = `/api/TrendsCharts/All`;
        showLoadingSpinner('#totals', '5rem');
        $('#totalVaccinatedValue').empty();
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#totals');
            let isProjected = false;
            for (var i = 0; i < data.length; i++) {
                if (data[i].projected >= 10) {
                    isProjected = true;
                    break;
                }
            }
            if (data.length > 2 && isProjected) {
                const chartOptions = {
                    title: {
                        text: ''
                    },
                    yAxis: {
                        title: { text: 'Total vaccinations' }
                    },
                    xAxis: {
                        categories: data.map(d => d.year + '-' + appConstants.monthLabels[d.month - 1]),
                    },
                    colors: ['#F36633', '#544F40'],
                    tooltip: {
                        formatter: function () {
                            if (this.y < 10) {
                                return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>< 10</b><br/>
                                </div>
                              `;
                            }
                            else {
                                return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>${this.y.toLocaleString('en-US')}</b><br/>
                                </div>
                              `;
                            }
                        }
                    },
                    series: [{
                        type: 'line',
                        name: 'Total Vaccinated',
                        data: data.map(d => {
                            return {
                                name: d.year + '-' + appConstants.monthLabels[d.month - 1],
                                y: (d.projected < 10) ? 1 : d.projected
                            };
                        })
                    }]
                };
                Highcharts.chart('totals', chartOptions);
            }
            else {
                Highcharts.setOptions({
                    lang: {
                        noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
                    },
                    noData: {
                        useHTML: true
                    }
                });
                Highcharts.chart('totals', {
                    title: {
                        text: ''
                    }
                });
            }
            this.populateTotalChart(data);
        });
    }

    populateGapTotalChart() {
        const url = `/api/TrendsCharts/Totals`;
        showLoadingSpinner('#gap', '5rem');
        showLoadingSpinner('#gapChart');
        $('#gapValue').empty();
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#gap');
            hideLoadingSpinner('#gapChart');
            let isProjected = false;
            for (var i = 0; i < data.length; i++) {
                if (data[i].previousYearProjected >= 10 || data[i].currentYearProjected >= 10) {
                    isProjected = true;
                    break;
                }
            }
            if (data.length > 2 && isProjected) {
                const chartOptions = {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        useHTML: true,
                        formatter: function () {
                            const percent = this.points[0].y > 0 ? (this.points[2].y / this.points[0].y) * 100 : 0;
                            return `
                            <h6 class="chart-tooltip-header">${this.x}</h6>
                            <div class="chart-tooltip-body">
                                ${this.points.map(point => {
                                return `
                                        <div class="chart-tooltip-item">
                                            <span class="chart-tooltip-item-bullet" style="color:${point.color};">●</span>
                                            <span class="chart-tooltip-item-name">${point.series.name}</span>
                                            <span class="chart-tooltip-item-value">${point.y.toLocaleString('en-US')}</span>
                                        </div>
                                    `;
                            }).join('')}
                                <div class="chart-tooltip-item">
                                    <span class="chart-tooltip-item-name">% Difference</span>
                                    <span class="chart-tooltip-item-value">${percent.toLocaleString('en-US', { maximumFractionDigits: 0 })}%</span>
                                </div>
                            </div>
                        `;
                        },
                        shared: true
                    },
                    xAxis: {
                        categories: data.map(d => appConstants.monthLabels[d.month - 1]),
                    },
                    yAxis: [{
                        alignTicks: false,
                        title: {
                            text: 'Total vaccinations'
                        }
                    }, {
                        gridLineWidth: 0,
                        title: {
                            text: 'Year over year difference'
                        },
                        opposite: true,
                        plotLines: [{
                            width: 2,
                            value: 0,
                            zIndex: 4
                        }]
                    }],
                    series: [{
                        type: 'line',
                        zIndex: 3,
                        name: `${this.filters.timePeriod2}`,
                        color: '#F36633',
                        data: data.map(d => {
                            return {
                                name: appConstants.monthLabels[d.month - 1],
                                y: d.previousYearProjected
                            };
                        })
                    }, {
                        type: 'line',
                        zIndex: 2,
                        name: `${this.filters.timePeriod}`,
                        color: '#544F40',
                        data: data.map(d => {
                            return {
                                name: appConstants.monthLabels[d.month - 1],
                                y: d.currentYearProjected
                            };
                        })
                    }, {
                        type: 'column',
                        name: `Difference`,
                        color: 'rgba(243, 102, 51, 0.7)',
                        yAxis: 1,
                        zIndex: 1,
                        negativeColor: 'rgba(84, 79, 64, 0.7)',
                        data: data.map(d => {
                            return {
                                name: appConstants.monthLabels[d.month - 1],
                                y: d.diffProjected
                            };
                        })
                    }]
                };
                Highcharts.chart('gap', chartOptions);
            }
            else {
                Highcharts.setOptions({
                    lang: {
                        noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
                    },
                    noData: {
                        useHTML: true
                    }
                });
                Highcharts.chart('gap', {
                    title: {
                        text: ''
                    }
                });
            }
            this.populateGapChart(data);
        });
    }

    populateGapAgeChart() {
        const url = `/api/TrendsCharts/Age`;
        showLoadingSpinner('#age', '5rem');
        showLoadingSpinner('#totalAgeChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#age');
            hideLoadingSpinner('#totalAgeChart');
            const dataByAgeGroup = this.formatData(data, 'ageGroupName');
            let isProjected = false;
            for (var i = 0; i < data.length; i++) {
                if (data[i].projected >= 10) {
                    isProjected = true;
                    break;
                }
            }
            if (data.length > 2 && isProjected) {
                const chartOptions = {
                    title: {
                        text: ''
                    },
                    yAxis: {
                        title: { text: 'Total vaccinations' }
                    },
                    xAxis: {
                        categories: this.formatData(data, 'month').map(d => appConstants.monthLabels[d['month'] - 1]),
                    },
                    colors: ['#147189', '#F36633', '#544F40'],
                    tooltip: {
                        formatter: function () {
                            if (this.y < 10) {
                                return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>< 10</b><br/>
                                </div>
                              `;
                            }
                            else {
                                return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>${this.y.toLocaleString('en-US')}</b><br/>
                                </div>
                              `;
                            }
                        }
                    },
                    series: dataByAgeGroup.map(group => {
                        return {
                            type: 'column',
                            name: group['ageGroupName'],
                            data: group.data.map(d => {
                                return {
                                    name: appConstants.monthLabels[d.month - 1],
                                    y: (d.projected < 10) ? 1 : d.projected
                                };
                            })
                        }
                    })
                };
                Highcharts.chart('age', chartOptions);
            }
            else {
                Highcharts.setOptions({
                    lang: {
                        noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
                    },
                    noData: {
                        useHTML: true
                    }
                });
                Highcharts.chart('age', {
                    title: {
                        text: ''
                    }
                });
            }
            this.populateTotalAgeChart(dataByAgeGroup);
        });
    }

    populateGapGenderChart() {
        const url = `/api/TrendsCharts/Gender`;
        showLoadingSpinner('#gender', '5rem');
        showLoadingSpinner('#totalGenderChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#gender');
            hideLoadingSpinner('#totalGenderChart');
            const dataByGender = this.formatData(data, 'genderName');
            let isProjected = false;
            for (var i = 0; i < data.length; i++) {
                if (data[i].projected >= 10) {
                    isProjected = true;
                    break;
                }
            }
            if (data.length > 2 && isProjected) {
                const chartOptions = {
                    title: {
                        text: ''
                    },
                    yAxis: {
                        title: { text: 'Total vaccinations' }
                    },
                    xAxis: {
                        categories: this.formatData(data, 'month').map(d => appConstants.monthLabels[d['month'] - 1]),
                    },
                    tooltip: {
                        useHTML: true,
                        formatter: function () {
                            const total = this.points[1] != undefined ? this.points[0].y + this.points[1].y : this.points[0].y;
                            if (total != this.points[0].y) {
                                var totLabel = (this.points[0].y < 10 || this.points[1].y < 10) ? 'Not enough data' : total.toLocaleString('en-US');
                                return `
                                <h6 class="chart-tooltip-header">${this.x}</h6>
                                <div class="chart-tooltip-body">
                                ${this.points.map(point => {
                                    var label = point.y < 10 ? '< 10' : point.y.toLocaleString('en-US');
                                    return `
                                        <div class="chart-tooltip-item">
                                            <span class="chart-tooltip-item-bullet" style="color:${point.color};">●</span>
                                            <span class="chart-tooltip-item-name">${point.series.name}</span>
                                            <span class="chart-tooltip-item-value">${label}</span>
                                        </div>
                                    `;
                                }).join('')}
                                <div class="chart-tooltip-item">
                                    <span class="chart-tooltip-item-name">Total</span>
                                    <span class="chart-tooltip-item-value">${totLabel.toLocaleString('en-US')}</span>
                                </div>
                            </div>
                            `;
                            } else {
                                return `
                                <h6 class="chart-tooltip-header">${this.x}</h6>
                                <div class="chart-tooltip-body">
                                ${this.points.map(point => {
                                    var label = point.y < 10 ? '< 10' : point.y.toLocaleString('en-US');
                                    return `
                                        <div class="chart-tooltip-item">
                                            <span class="chart-tooltip-item-bullet" style="color:${point.color};">●</span>
                                            <span class="chart-tooltip-item-name">${point.series.name}</span>
                                            <span class="chart-tooltip-item-value">${label}</span>
                                        </div>
                                    `;
                                }).join('')}`;
                            }
                        },
                        shared: true
                    },

                    colors: ['#F36633', '#544F40'],
                    series: dataByGender.map(group => {
                        return {
                            type: 'line',
                            name: group['genderName'],
                            data: group.data.map(d => {
                                return {
                                    name: appConstants.monthLabels[d.month - 1],
                                    y: (d.projected < 10) ? 1 : d.projected
                                };
                            })
                        }
                    })
                };
                Highcharts.chart('gender', chartOptions);
            }
            else {
                Highcharts.setOptions({
                    lang: {
                        noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
                    },
                    noData: {
                        useHTML: true
                    }
                });
                Highcharts.chart('gender', {
                    title: {
                        text: ''
                    }
                });
            }
            this.populateTotalGenderChart(dataByGender);
        });
    }

    populateGapEthnicityChart() {
        const url = `/api/TrendsCharts/Ethnicity`;
        showLoadingSpinner('#ethnicity', '5rem');
        showLoadingSpinner('#totalEthnicityChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#ethnicity');
            hideLoadingSpinner('#totalEthnicityChart');
            const dataByEthnicity = this.formatData(data, 'ethnicityName');
            let isProjected = false;
            for (var i = 0; i < data.length; i++) {
                if (data[i].projected >= 10) {
                    isProjected = true;
                    break;
                }
            }
            if (data.length > 2 && isProjected) {
                const chartOptions = {
                    title: {
                        text: ''
                    },
                    yAxis: {
                        title: { text: 'Total vaccinations' }
                    },
                    xAxis: {
                        categories: this.formatData(data, 'month').map(d => appConstants.monthLabels[d['month'] - 1]),
                    },
                    tooltip: {
                        useHTML: true,
                        formatter: function () {
                            let total = 0;
                            if (this.points != undefined) {
                                for (var i = 0; i < this.points.length; i++) {
                                    if (this.points[i].y >= 10) {
                                        total = total + this.points[i].y;
                                    }
                                }
                            }
                            if (total != 0) {
                                return `
                                <h6 class="chart-tooltip-header">${this.x}</h6>
                                <div class="chart-tooltip-body">
                                ${this.points.map(point => {
                                    var label = point.y < 10 ? '< 10' : point.y.toLocaleString('en-US');
                                    return `
                                        <div class="chart-tooltip-item">
                                            <span class="chart-tooltip-item-bullet" style="color:${point.color};">●</span>
                                            <span class="chart-tooltip-item-name">${point.series.name}</span>
                                            <span class="chart-tooltip-item-value">${label}</span>
                                        </div>
                                    `;
                                }).join('')}
                                <div class="chart-tooltip-item">
                                    <span class="chart-tooltip-item-name">Total</span>
                                    <span class="chart-tooltip-item-value">${total.toLocaleString('en-US')}</span>
                                </div>
                            </div>
                            `;
                            } else {
                                return `
                                <h6 class="chart-tooltip-header">${this.x}</h6>
                                <div class="chart-tooltip-body">
                                ${this.points.map(point => {
                                    var label = point.y < 10 ? '< 10' : point.y.toLocaleString('en-US');
                                    return `
                                        <div class="chart-tooltip-item">
                                            <span class="chart-tooltip-item-bullet" style="color:${point.color};">●</span>
                                            <span class="chart-tooltip-item-name">${point.series.name}</span>
                                            <span class="chart-tooltip-item-value">${label}</span>
                                        </div>
                                    `;
                                }).join('')}`;
                            }
                        },
                        shared: true
                    },
                    colors: ['#147189', '#544F40', '#F79470', '#F36633', 'rgba(84, 79, 64, 0.7)'],
                    series: dataByEthnicity.map(group => {
                        return {
                            type: 'line',
                            name: group['ethnicityName'],
                            data: group.data.map(d => {
                                return {
                                    name: appConstants.monthLabels[d.month - 1],
                                    y: (d.projected < 10) ? 1 : d.projected
                                };
                            })
                        }
                    })
                };
                Highcharts.chart('ethnicity', chartOptions);
            }
            else {
                Highcharts.setOptions({
                    lang: {
                        noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
                    },
                    noData: {
                        useHTML: true
                    }
                });
                Highcharts.chart('ethnicity', {
                    title: {
                        text: ''
                    }
                });
            }
            this.populateTotalEthnicityChart(dataByEthnicity);
        });
    }

    populateGapPayerChart() {
        const url = `/api/TrendsCharts/Payor`;
        showLoadingSpinner('#payer', '5rem');
        showLoadingSpinner('#totalPayerChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#payer');
            hideLoadingSpinner('#totalPayerChart');
            const dataByPayer = this.formatData(data, 'payorName');
            let isProjected = false;
            for (var i = 0; i < data.length; i++) {
                if (data[i].projected >= 10) {
                    isProjected = true;
                    break;
                }
            }
            if (data.length > 2 && isProjected) {
                const chartOptions = {
                    title: {
                        text: ''
                    },
                    yAxis: {
                        title: { text: 'Total vaccinations' }

                    },
                    xAxis: {
                        categories: this.formatData(data, 'month').map(d => appConstants.monthLabels[d['month'] - 1]),
                    },
                    tooltip: {
                        useHTML: true,
                        formatter: function () {
                            let total = 0;
                            if (this.points != undefined) {
                                for (var i = 0; i < this.points.length; i++) {
                                    if (this.points[i].y >= 10) {
                                        total = total + this.points[i].y;
                                    }
                                }
                            }
                            if (total != 0) {
                                return `
                                <h6 class="chart-tooltip-header">${this.x}</h6>
                                <div class="chart-tooltip-body">
                                ${this.points.map(point => {
                                    var label = point.y < 10 ? '< 10' : point.y.toLocaleString('en-US');
                                    return `
                                        <div class="chart-tooltip-item">
                                            <span class="chart-tooltip-item-bullet" style="color:${point.color};">●</span>
                                            <span class="chart-tooltip-item-name">${point.series.name}</span>
                                            <span class="chart-tooltip-item-value">${label}</span>
                                        </div>
                                    `;
                                }).join('')}
                                <div class="chart-tooltip-item">
                                    <span class="chart-tooltip-item-name">Total</span>
                                    <span class="chart-tooltip-item-value">${total.toLocaleString('en-US')}</span>
                                </div>
                            </div>
                            `;
                            } else {
                                return `
                                <h6 class="chart-tooltip-header">${this.x}</h6>
                                <div class="chart-tooltip-body">
                                ${this.points.map(point => {
                                    var label = point.y < 10 ? '< 10' : point.y.toLocaleString('en-US');
                                    return `
                                        <div class="chart-tooltip-item">
                                            <span class="chart-tooltip-item-bullet" style="color:${point.color};">●</span>
                                            <span class="chart-tooltip-item-name">${point.series.name}</span>
                                            <span class="chart-tooltip-item-value">${label}</span>
                                        </div>
                                    `;
                                }).join('')}`;
                            }
                        },
                        shared: true
                    },
                    colors: ['#147189', '#544F40', '#F79470', '#F36633', 'rgba(84, 79, 64, 0.7)', 'rgba(84, 79, 64, 0.5)'],
                    series: dataByPayer.map(group => {
                        return {
                            type: 'line',
                            name: group.payorName,
                            data: group.data.map(d => {
                                return {
                                    name: appConstants.monthLabels[d.month - 1],
                                    y: (d.projected < 10) ? 1 : d.projected
                                };
                            })
                        }
                    })
                };
                Highcharts.chart('payer', chartOptions);
            }
            else {
                Highcharts.setOptions({
                    lang: {
                        noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
                    },
                    noData: {
                        useHTML: true
                    }
                });
                Highcharts.chart('payer', {
                    title: {
                        text: ''
                    }
                });
            }
            this.populateTotalPayerChart(dataByPayer);
        });
    }


    populateTotalChart(data) {
        let totalVaccinated = 0;
        totalVaccinated = data.reduce((sum, d) => sum + d.projected, 0);
        totalVaccinated = totalVaccinated < 10 ? '< 10' : totalVaccinated;
        $('#totalVaccinatedValue').html(totalVaccinated.toLocaleString('en-US'));
    }

    populateGapChart(data) {
        const totalGap = data.reduce((sum, d) => sum + d.diffProjected, 0);
        const totalProj = data.reduce((sum, d) => sum + d.previousYearProjected, 0);
        const percentage = totalProj !== 0 ? (totalGap / totalProj) * 100 : 0;
        const chartData = [{
            name: '',
            color: '#F36633',
            y: Math.abs(percentage)
        },
        {
            name: '', // + data.timePeriod2 + ' year projected',
            color: '#F0EFED',
            y: 100 - Math.abs(percentage)
        }];

        $('#gapValue').html(totalGap <= 0 ? totalGap.toLocaleString('en-US') : '+' + totalGap.toLocaleString('en-US'));

        const chartOptions = {
            chart: {
                height: 117,
                width: 117
            },
            title: {
                verticalAlign: 'middle',
                floating: true,
                text: `${percentage <= 0 ? percentage.toFixed() : '+' + percentage.toFixed()}%`,
                style: {
                    fontSize: '24px'
                }
            },
            plotOptions: {
                pie: {
                    size: 112,
                    innerSize: '80%',
                    states: {
                        hover: {
                            enabled: false
                        },
                        inactive: {
                            opacity: 1
                        }
                    }
                }
            },
            tooltip: {
                //enabled: false
                outside: true,
                useHTML: true,
                formatter: function () {
                    if (this.point.index > 0 && percentage > 0 || this.point.index == 0 && percentage < 0) {
                        return false;
                    } else {
                        return `
                             <h6 class="chart-tooltip-header" > ${this.series.name}</h6 >
                             <div class="chart-tooltip-body">
                                 <div class="chart-tooltip-item">
                                         <span class="chart-tooltip-item-value">${new Intl.NumberFormat("en-US", { signDisplay: "exceptZero", maximumFractionDigits: 1 }).format(percentage)}%</span>

                                 </div>
                             </div>
                          `;

                    }
                }
            },
            legend: {
                enabled: false
            },
            series: [{
                type: 'pie',
                name: 'Total percent change',
                data: percentage >= 0 ? chartData : chartData.reverse()
            }]
        };
        Highcharts.setOptions({
            lang: {
                noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
            },
            noData: {
                useHTML: true
            }
        });
        Highcharts.chart('gapChart', chartOptions);
    }

    populateTotalAgeChart(data) {
        let isSumProjected = false;
        let projectedValues = data.map(group => {
            return {
                total: group.data.reduce((sum, d) => sum + d.projected, 0)
            };
        })
        projectedValues.every(t => {
            if (t.total >= 10) {
                isSumProjected = true;
                return false;
            }
            return true;
        });

        if (!isSumProjected) {
            data = [];
        }
        const chartOptions = {
            chart: {
                width: null,
                height: 300
            },
            title: {
                text: ''
            },
            plotOptions: {
                pie: {
                    innerSize: '60%'
                }
            },
            colors: ['#147189', '#F36633', '#544F40'],
            tooltip: {
                formatter: function () {
                    this.valueDecimals = 2;
                    var result;
                    if (this.y < 10) {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>< 10</b><br/>
                                </div>
                              `;
                    }
                    else {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>${this.y.toLocaleString('en-US')}</b><br/>
                                </div>
                              `;
                    }
                    return result;
                }
            },
            series: [{
                type: 'pie',
                name: 'Total',
                data: data.map(group => {
                    return {
                        name: group.ageGroupName,
                        y: group.data.reduce((sum, d) => sum + d.projected, 0)
                    };
                })
            }]
        };
        Highcharts.setOptions({
            lang: {
                noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
            },
            noData: {
                useHTML: true
            }
        });
        Highcharts.chart('totalAgeChart', chartOptions);
    }

    populateTotalGenderChart(data) {
        let isSumProjected = false;
        let projectedValues = data.map(group => {
            return {
                total: group.data.reduce((sum, d) => sum + d.projected, 0)
            };
        })
        projectedValues.every(t => {
            if (t.total >= 10) {
                isSumProjected = true;
                return false;
            }
            return true;
        });

        if (!isSumProjected) {
            data = [];
        }
        const chartOptions = {
            chart: { width: null, height: 300 },
            title: {
                text: ''
            },
            plotOptions: {
                pie: {
                    innerSize: '60%'
                }
            },
            colors: ['#F36633', '#544F40'],
            tooltip: {
                formatter: function () {
                    if (this.y < 10) {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>< 10</b><br/>
                                </div>
                              `;
                    }
                    else {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>${this.y.toLocaleString('en-US')}</b> (${Math.round(this.point.percentage)}%)<br/>
                                </div>
                              `;
                    }
                }
            },
            series: [{
                type: 'pie',
                name: 'Total',
                data: data.map(group => {
                    return {
                        name: group.genderName,
                        y: group.data.reduce((sum, d) => sum + d.projected, 0)
                    };
                })
            }]
        };
        Highcharts.setOptions({
            lang: {
                noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
            },
            noData: {
                useHTML: true
            }
        });
        Highcharts.chart('totalGenderChart', chartOptions);
    }

    populateTotalEthnicityChart(data) {
        let isSumProjected = false;
        let projectedValues = data.map(group => {
            return {
                total: group.data.reduce((sum, d) => sum + d.projected, 0)
            };
        })
        projectedValues.every(t => {
            if (t.total >= 10) {
                isSumProjected = true;
                return false;
            }
            return true;
        });

        if (!isSumProjected) {
            data = [];
        }
        const chartOptions = {
            chart: { width: null, height: 300 },
            title: {
                text: ''
            },
            tooltip: {
                formatter: function () {
                    if (this.y < 10) {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>< 10</b><br/>
                                </div>
                              `;
                    }
                    else {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>${this.y.toLocaleString('en-US')}</b> (${Math.round(this.point.percentage)}%)<br/>
                                </div>
                              `;
                    }
                }
            },
            plotOptions: {
                pie: {
                    innerSize: '60%'
                }
            },
            colors: ['#147189', '#544F40', '#F79470', '#F36633', 'rgba(84, 79, 64, 0.7)'],
            series: [{
                type: 'pie',
                name: 'Total',
                data: data.map(group => {
                    return {
                        name: group.ethnicityName,
                        y: group.data.reduce((sum, d) => sum + d.projected, 0)
                    };
                })
            }]
        };
        Highcharts.setOptions({
            lang: {
                noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
            },
            noData: {
                useHTML: true
            }
        });
        Highcharts.chart('totalEthnicityChart', chartOptions);
    }

    populateTotalPayerChart(data) {
        let isSumProjected = false;
        let projectedValues = data.map(group => {
            return {
                total: group.data.reduce((sum, d) => sum + d.projected, 0)
            };
        })
        projectedValues.every(t => {
            if (t.total >= 10) {
                isSumProjected = true;
                return false;
            }
            return true;
        });

        if (!isSumProjected) {
            data = [];
        }
        const chartOptions = {
            chart: { width: null, height: 300 },
            title: {
                text: ''
            },
            plotOptions: {
                pie: {
                    innerSize: '60%'
                }
            },
            colors: ['#147189', '#544F40', '#F79470', '#F36633', 'rgba(84, 79, 64, 0.7)', 'rgba(84, 79, 64, 0.5)'],
            tooltip: {
                formatter: function () {
                    this.valueDecimals = 2;
                    var result;
                    if (this.y < 10) {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>< 10</b><br/>
                                </div>
                              `;
                    }
                    else {
                        return `<div>
                                    ${this.point.name}<br/>
                                </div>
                                <div>
                                  <span style="color:${this.point.color}">●&nbsp;</span> ${this.series.name}: <b>${this.y.toLocaleString('en-US')}</b> (${Math.round(this.point.percentage)}%)<br/>
                                </div>
                              `;
                    }
                    return result;
                }
            },
            series: [{
                type: 'pie',
                name: 'Total',
                data: data.map(group => {
                    return {
                        name: group.payorName,
                        y: group.data.reduce((sum, d) => sum + d.projected, 0)
                    };
                })
            }]
        };
        Highcharts.setOptions({
            lang: {
                noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
            },
            noData: {
                useHTML: true
            }
        });
        Highcharts.chart('totalPayerChart', chartOptions);
    }

    formatData(data, key) {
        if (data.length > 0) {
            const groupedData = data.reduce((acc, value) => {
                // Group initialization
                if (!acc[value[key]]) {
                    acc[value[key]] = [];
                }

                // Grouping
                acc[value[key]].push(value);

                return acc;
            }, {});

            return Object.keys(groupedData).map(k => {
                return {
                    [key]: k,
                    data: groupedData[k]
                }
            });
        } else {
            return [];
        }
    }
}

$(() => {
    $('#mainContentLoading').addClass('d-none');
    $('#mainContent').removeClass('d-none');
    new TrendPage();
});